module.exports = __webpack_public_path__ + "static/media/Памятка покупателю английский язык.2310f565.pdf";